import api from '~/services/api';
import { cstProps, formDataProps } from '../types';

const createIbsCbs = async (
  dataForm: formDataProps,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.post('/classificacao-ibs-cbs/create', dataForm);
  return data;
};

const updateIbsCbs = async (
  cod_ibs_cbs: number,
  dataForm: formDataProps,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.put(
    `/classificacao-ibs-cbs/${cod_ibs_cbs}`,
    dataForm,
  );
  return data;
};

const inativaIbsCbs = async (
  cod_ibs_cbs: number,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.delete(`/classificacao-ibs-cbs/${cod_ibs_cbs}`);
  return data;
};

const ativarIbsCbs = async (
  cod_ibs_cbs: number,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.put(
    `/classificacao-ibs-cbs/active/${cod_ibs_cbs}`,
  );
  return data;
};

const createCST = async (
  dataForm: cstProps,
): Promise<{ cod_cst_ibs_cbs: number; message: string; success: boolean }> => {
  const { data } = await api.post(`/classificacao-ibs-cbs/cst`, dataForm);
  return data;
};

export const IbsCbsServices = {
  createIbsCbs,
  updateIbsCbs,
  inativaIbsCbs,
  ativarIbsCbs,
  createCST,
};
